/**
 * @generated SignedSource<<905ddfad72a7a80690e78d2396f6046f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutPaymentMethodContent_buyer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutBankAccounts_buyer" | "CheckoutCheckWrapper_buyer" | "CheckoutCreditCards_buyer" | "CheckoutKlarnaPayment_buyer" | "CheckoutPayPalWrapper_buyer" | "CheckoutWireTransferWrapper_buyer">;
  readonly " $fragmentType": "CheckoutPaymentMethodContent_buyer";
};
export type CheckoutPaymentMethodContent_buyer$key = {
  readonly " $data"?: CheckoutPaymentMethodContent_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutPaymentMethodContent_buyer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutPaymentMethodContent_buyer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutCreditCards_buyer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutPayPalWrapper_buyer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutWireTransferWrapper_buyer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutCheckWrapper_buyer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutBankAccounts_buyer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutKlarnaPayment_buyer"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "dd638979b50493a710fc058bbb4ee46c";

export default node;
